<template lang="pug">
transition(name="modal-como-funciona-fade")
  .modal-como-funciona(v-if="visible" @keydown.esc="fechar")
    .modal-como-funciona__overlay(@click="fechar")
    aside.modal-como-funciona__drawer(role="dialog" aria-labelledby="modal-como-funciona-titulo")
      header.modal-como-funciona__header
        h2#modal-como-funciona-titulo.modal-como-funciona__title Como funciona?
        button.modal-como-funciona__close(type="button" aria-label="Fechar" @click="fechar")
          i.fas.fa-times

      .modal-como-funciona__content
        p.modal-como-funciona__intro {{ intro }}

        ol.modal-como-funciona__timeline
          li.modal-como-funciona__step(
            v-for="(step, index) in steps"
            :key="step.titulo"
            :class="{ 'modal-como-funciona__step--final': step.final }"
          )
            .modal-como-funciona__step-track
              span.modal-como-funciona__step-circle
              span.modal-como-funciona__step-line(v-if="index < steps.length - 1")

            .modal-como-funciona__step-content
              h3.modal-como-funciona__step-title {{ step.titulo }}
              .modal-como-funciona__step-info
                p.modal-como-funciona__step-description {{ step.descricao }}
                p.modal-como-funciona__step-observacao(v-if="step.observacao") {{ step.observacao }}
</template>

<script>
import { COMO_FUNCIONA_INTRO, COMO_FUNCIONA_STEPS } from '@/constants/editaisPublico'

export default {
  name: 'ModalComoFunciona',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      intro: COMO_FUNCIONA_INTRO,
      steps: COMO_FUNCIONA_STEPS
    }
  },
  watch: {
    visible (aberto) {
      document.body.style.overflow = aberto ? 'hidden' : ''
    }
  },
  beforeDestroy () {
    document.body.style.overflow = ''
  },
  methods: {
    fechar () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-como-funciona {
  inset: 0;
  position: fixed;
  z-index: 3000;
}

.modal-como-funciona__overlay {
  background: rgba(0, 0, 0, 0.4);
  inset: 0;
  position: absolute;
}

.modal-como-funciona__drawer {
  background: #ffffff;
  border-left: 1px solid #eaeaea;
  border-radius: 12px 0 0 12px;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-left: auto;
  max-width: 100%;
  position: relative;
  width: 512px;
  z-index: 1;
}

.modal-como-funciona__header {
  align-items: center;
  border-bottom: 1px solid #eaeaea;
  display: flex;
  justify-content: space-between;
  padding: 16px;
  position: relative;
}

.modal-como-funciona__title {
  color: #141414;
  font-family: 'Poppins', 'Ubuntu', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0;
}

.modal-como-funciona__close {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #141414;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  height: 40px;
  justify-content: center;
  transition: background-color 0.2s ease;
  width: 40px;

  i {
    font-size: 16px;
  }

  &:hover {
    background: #f5f5f5;
  }
}

.modal-como-funciona__content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.modal-como-funciona__intro {
  color: #8a8a8a;
  font-family: 'Ubuntu', sans-serif;
  font-size: 14px;
  line-height: 1.15;
  margin: 0 0 16px;
}

.modal-como-funciona__timeline {
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
}

.modal-como-funciona__step {
  display: flex;
  gap: 16px;
}

.modal-como-funciona__step-track {
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 14px;
}

.modal-como-funciona__step-circle {
  background: #18c5c2;
  border: 2px solid #ffffff;
  border-radius: 7px;
  box-sizing: border-box;
  display: block;
  flex-shrink: 0;
  height: 14px;
  width: 14px;
}

.modal-como-funciona__step-line {
  background: #eaeaea;
  flex: 1;
  margin: 4px 0;
  min-height: 24px;
  width: 2px;
}

.modal-como-funciona__step-content {
  flex: 1;
  min-width: 0;
  padding-bottom: 24px;
}

.modal-como-funciona__step-title {
  color: #141414;
  font-family: 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 8px;
}

.modal-como-funciona__step-info {
  background: #f5f5f5;
  border-left: 3px solid #18c5c2;
  border-radius: 0 8px 8px 0;
  padding: 16px 20px;
}

.modal-como-funciona__step-description {
  color: #8a8a8a;
  font-family: 'Ubuntu', sans-serif;
  font-size: 14px;
  line-height: 1.3;
  margin: 0;
}

.modal-como-funciona__step-observacao {
  color: #8a8a8a;
  font-family: 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.3;
  margin: 6px 0 0;
}

.modal-como-funciona__step--final {
  .modal-como-funciona__step-circle {
    background: #00a73d;
  }

  .modal-como-funciona__step-info {
    border-left-color: #00a73d;
  }
}

.modal-como-funciona-fade-enter-active,
.modal-como-funciona-fade-leave-active {
  transition: opacity 0.25s ease;

  .modal-como-funciona__drawer {
    transition: transform 0.25s ease;
  }
}

.modal-como-funciona-fade-enter,
.modal-como-funciona-fade-leave-to {
  opacity: 0;

  .modal-como-funciona__drawer {
    transform: translateX(100%);
  }
}

@media (max-width: 560px) {
  .modal-como-funciona__drawer {
    border-radius: 0;
    width: 100%;
  }
}
</style>
